import React from "react";
import {useSelector} from "react-redux";
import PageHeader from "../../components/page-header";
import ArchiveEntityControl from "../../../system/components/archive-entity-control";
import {useTranslate} from "../../../system/useTranslate";
import {useWorkspaceRole} from "../../../system/use-workspace-role";
import {useWorkspace} from "../../../models/workspace/use-workspace";

function WorkspaceSettings() {
    const translate = useTranslate();
    const workspace = useWorkspace();
    const {role} = useWorkspaceRole();
    const workspaceData = useSelector((state) => state.app.workspaceMembershipData?.workspace);

    if (role !== "owner") return null;

    return (
        <div className="flex flex-column p-4 gap-4 overflow-auto h-full">
            <PageHeader
                title="workspace-settings"
                description="workspace-settings-description"
                titleClassName="text-lg"
                descriptionClassName="text-xs"
            />
            <div className="w-full lg:w-8">
                <ArchiveEntityControl
                    entityName={workspaceData?.name}
                    sectionTitle={translate("manage-workspace")}
                    title={translate("archive-workspace-title")}
                    description={translate("archive-workspace-description")}
                    buttonLabel={translate("archive-workspace")}
                    dialogTitle={translate("archive-workspace-confirm-title")}
                    onArchive={() => workspace.archiveWorkspace(workspaceData?.documentId)}
                />
            </div>
        </div>
    );
}

export default WorkspaceSettings;
